import { render, staticRenderFns } from "./SignForm.vue?vue&type=template&id=48dcd400&"
import script from "./SignForm.vue?vue&type=script&lang=js&"
export * from "./SignForm.vue?vue&type=script&lang=js&"
import style0 from "./SignForm.vue?vue&type=style&index=0&id=48dcd400&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports